<div fxLayout="column">
  <div class="week-header">
    <div
      *ngFor="let day of daysOfWeek; trackBy: trackByDay"
      class="week-header-day"
      fxFlex
      [ngClass]="{ 'week-header-today': isTodayHeader(day) }"
    >
      {{ day | titlecase }}
    </div>
  </div>
  <ng-container *ngIf="monthMap$ | async as monthMap">
    <pr-week-row
      *ngFor="let row of monthMap; trackBy: trackByMonth"
      fxFlex
      [days]="row.days"
     />
  </ng-container>
</div>
